import { Question, MetaType, InteractionType, TTS } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  getArrayReducerGuard,
  processActionMeta
} from "../reducers"

const kind = "block_interactions"

export interface MultipeChoice {}

export interface Poll {
  display: boolean
}

export interface MiniTest {
  meta: MetaType
}

export interface ClickZone {
  meta: MetaType
}

export type BlockInteraction = {
  kind: typeof kind
  version: number
  type: InteractionType
  questions: Array<Question>
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockInteraction, MetaType>("meta", kind),
  type: actionCreatorGuard<BlockInteraction, InteractionType>("type", kind),
  questions: actionCreatorGuard<BlockInteraction, Array<Question>>(
    "questions",
    kind
  )
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockInteraction,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockInteractionAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

// Our exported reducer
export const blockInteractionReducer = reducerGuard<BlockInteraction>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.type)
  .case(...reducerAction.questions)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "questions":
        return getArrayReducerGuard<BlockInteraction, Question>(
          kind,
          "questions",
          "Question",
          prevState,
          action
        )
    }

    return prevState
  })
